import { IProjectState } from './ProjectState';
import { PayloadAction } from '@reduxjs/toolkit';

export function setReadonlyReducer(state: IProjectState, action: PayloadAction<boolean>) {
  if (state) {
    state.isReadonly = action.payload;
  }
}
